import { useContext } from "react";
import { AccrualMatchCtx } from "./accrualMatch.context";

export function useAccrualMatch() {
    return useContext(AccrualMatchCtx);
}
